import Tippy from '@tippyjs/react';
import classNames from 'classnames/bind';
import { Field } from 'formik';
import PropTypes from 'prop-types';
import React from 'react';
import AutosizeInput from 'react-input-autosize';

import FormattedText from 'uikit/FormattedText';

import text2React from '../text2React';
import styles from './Recto.module.scss';

const cx = classNames.bind(styles);

const Recto = ({
  answer,
  className,
  handleChoiceSelect,
  isDisabled,
  question,
  t,
  theme,
}) => {
  const questionText = () => {
    let i = 0;
    return text2React(question.content.text, {
      // eslint-disable-next-line consistent-return
      replace: ({ name, attribs }) => {
        if (name === 'select') {
          const choices = decodeURIComponent(attribs.data)
            .replace(/\\,/g, '#_FAKE_COMMA_#')
            .split(',')
            .map((ele) => ele.replace(/#_FAKE_COMMA_#/g, ','));
          const index = i;
          i += 1;
          return (
            <>
              <Tippy
                content={
                  <div className={cx('choices')}>
                    {choices &&
                      choices.map((choice, j) => (
                        <button
                          className={cx('choice', { disabled: isDisabled })}
                          disabled={isDisabled}
                          id={`choice-${i}-${j}`}
                          // eslint-disable-next-line react/no-array-index-key
                          key={j}
                          onClick={() => handleChoiceSelect(choice, index)}
                          type="button"
                        >
                          {choice.trim() || ' '}
                        </button>
                      ))}
                  </div>
                }
                duration={0}
                interactive
                maxWidth="none"
                placement="bottom"
                plugins={[
                  {
                    name: 'hideOnClick',
                    defaultValue: true,
                    fn(instance) {
                      return {
                        onCreate() {
                          instance.popper.addEventListener('click', () => {
                            instance.hide();
                          });
                        },
                      };
                    },
                  },
                  {
                    name: 'showOnCreate',
                    defaultValue: true,
                    fn(instance) {
                      return {
                        onCreate() {
                          if (index === 0) {
                            instance.show();
                          }
                        },
                      };
                    },
                  },
                  {
                    name: 'hideOnPopperBlur',
                    defaultValue: true,
                    fn(instance) {
                      return {
                        onCreate() {
                          instance.popper.addEventListener(
                            'focusout',
                            (event) => {
                              if (
                                instance.props.hideOnPopperBlur &&
                                event.relatedTarget &&
                                !instance.popper.contains(event.relatedTarget)
                              ) {
                                instance.hide();
                              }
                            },
                          );
                        },
                      };
                    },
                  },
                ]}
                trigger="focus"
              >
                <button
                  // eslint-disable-next-line jsx-a11y/no-autofocus
                  autoFocus={i === 1}
                  className={cx('select', 'field')}
                  id={`blank-${i}`}
                  type="button"
                >
                  {answer[i - 1].trim() || ''}
                </button>
              </Tippy>
            </>
          );
        }
        if (name === 'input') {
          i += 1;
          return (
            <Field
              as={AutosizeInput}
              autoCapitalize="off"
              autoComplete="off"
              autoCorrect="off"
              autoFocus={i === 1}
              className={cx('blank', 'field')}
              disabled={isDisabled}
              key={i - 1}
              name={`answer.${i - 1}`}
              spellCheck="false"
            />
          );
        }
      },
    });
  };
  return (
    <div
      className={cx(
        'container',
        className,
        `theme-${theme}`,
      )}
    >
      <FormattedText className={cx('title')}>{question.title}</FormattedText>
      {!isDisabled && (
        <div className={cx('instructions')}>
          {t('Questions/FillInTheBlanks/Recto/instructions')}
        </div>
      )}
      <FormattedText className={cx('text')} isAlreadyFormatted>
        {questionText()}
      </FormattedText>
    </div>
  );
};

Recto.propTypes = {
  answer: PropTypes.array.isRequired,
  className: PropTypes.string,
  handleChoiceSelect: PropTypes.func.isRequired,
  isDisabled: PropTypes.bool.isRequired,
  question: PropTypes.object.isRequired,
  t: PropTypes.func.isRequired,
  theme: PropTypes.string.isRequired,
};

Recto.defaultProps = {
  className: undefined,
};

export default Recto;
